import React from 'react'
import './car-logo.css'
export default function CarLogo() {
  return (
    <div className='logo-container'>
        <div className="logo">
            <img src="assets/car-logo/toyota-logo-removebg-preview.png" alt="" />
        </div>
        <div className="logo">
            <img src="assets/car-logo/real-honda-logo-removebg-preview.png" alt="" />
        </div>
        <div className="logo">
            <img src="assets/car-logo/Tesla-Logo-PNG-Photo-removebg-preview.png" alt="" />
        </div>
        <div className="logo">
            <img src="assets/car-logo/lexus_logo-removebg-preview.png" alt="" />
        </div>
        <div className="logo">
            <img src="assets/car-logo/bmw-logo-removebg-preview.png" alt="" />
        </div>
    </div>
  )
}
